<template>
  <v-card flat>
    <v-card-title class="subheading">
      {{ editId === 0 ? "Add SizeScale" : "Edit SizeScale" }}
      <v-spacer />
      <v-icon @click="closeDialog" small class="grey--text"
        >fas fa-times</v-icon
      >
    </v-card-title>
    <hr />
    <v-card-text>
      <v-layout wrap>
        <v-flex xs12 class="pl-2">
          <v-text-field
            v-model="sizeScale.code"
            label="Group Code *"
            outlined
            dense
            :error="duplicateError"
            :rules="[getRule('Code')]"
          ></v-text-field>
        </v-flex>

        <v-flex xs12>
          <div class="d-flex align-center mb-2">
            <span class="subtitle-1">Ind Sizes (Max 7)</span>
            <v-spacer />
            <v-btn
              small
              color="primary"
              @click="addIndSize"
              :disabled="indSizes.length >= 7"
            >
              <v-icon small left>fas fa-plus</v-icon>
              Add
            </v-btn>
          </div>
        </v-flex>

        <v-flex
          xs12
          v-for="(item, index) in indSizes"
          :key="index"
          class="mb-2"
        >
          <v-layout align-center>
            <v-flex xs10>
              <v-text-field
                v-model="indSizes[index]"
                :label="'Ind Size ' + (index + 1) + ' *'"
                outlined
                dense
                :error="isDuplicateIndSize(index)"
                :rules="[getRule('Ind Size')]"
              ></v-text-field>
            </v-flex>
            <v-flex xs2 class="pl-2">
              <v-btn
                icon
                small
                color="red"
                @click="removeIndSize(index)"
                :disabled="indSizes.length === 1"
              >
                <v-icon small>fas fa-trash</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <div v-if="duplicateError" class="red--text text-center mt-2">
        Code and Ind Size combination already exists
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="closeDialog" :disabled="saving">Cancel</v-btn>
      <v-btn color="primary" @click="save" :loading="saving" :disabled="saving"
        >Save</v-btn
      >
    </v-card-actions>
  </v-card>
</template>
<script>
import SizeScaleModel from "@/api/service/SizeScaleService";
// import CompanyModel from "@/api/service/CompanyService";

export default {
  props: ["sizeScaleId"],
  data() {
    return {
      companies: [],
      allSizeScales: [],
      sizeScale: {
        company_id: null,
        code: "",
        sequence_num: "",
      },
      indSizes: [""],
      editId: null,
      duplicateError: false,
      saving: false,
      duplicateIndices: [],
    };
  },
  created: function () {},
  mounted: function () {
    this.editId = this.sizeScaleId;
    let company = localStorage.getItem("tiburaReportsUser");
    this.sizeScale.company_id = JSON.parse(company).data.User.company_id;
    if (this.editId !== 0) {
      this.getById();
    }
    // this.getCoppany();
    this.getAllSizeScales();
  },
  methods: {
    // getCoppany() {
    //   CompanyModel.findAll({})
    //     .then((response) => {
    //       this.companies = response;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
    addIndSize() {
      if (this.indSizes.length < 7) {
        this.indSizes.push("");
      }
    },
    removeIndSize(index) {
      if (this.indSizes.length > 1) {
        this.indSizes.splice(index, 1);
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    getRule(name) {
      return (v) => !!v || name + " is required";
    },
    isDuplicateIndSize(index) {
      return this.duplicateIndices.includes(index);
    },
    findDuplicateIndices() {
      const indices = [];
      const filledSizes = this.indSizes.map((s, i) => ({
        value: s ? s.trim() : "",
        index: i,
      }));

      // Check for duplicates within the form
      for (let i = 0; i < filledSizes.length; i++) {
        if (!filledSizes[i].value) continue;
        for (let j = i + 1; j < filledSizes.length; j++) {
          if (filledSizes[i].value === filledSizes[j].value) {
            if (!indices.includes(i)) indices.push(i);
            if (!indices.includes(j)) indices.push(j);
          }
        }
      }

      const id = this.editId !== 0 ? this.sizeScale.id : null;
      for (const item of filledSizes) {
        if (!item.value) continue;
        const duplicate = this.allSizeScales.find((record) => {
          if (id && record.id === id) return false;
          return (
            record.code === this.sizeScale.code &&
            record.ind_size === item.value &&
            record.company_id === this.sizeScale.company_id
          );
        });
        if (duplicate && !indices.includes(item.index)) {
          indices.push(item.index);
        }
      }

      return indices;
    },
    getById() {
      SizeScaleModel.getOne(this.editId)
        .then((response) => {
          this.sizeScale = response[0];
          if (this.sizeScale.ind_size) {
            if (Array.isArray(this.sizeScale.ind_size)) {
              this.indSizes = [...this.sizeScale.ind_size];
            } else {
              this.indSizes = [this.sizeScale.ind_size];
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAllSizeScales() {
      SizeScaleModel.getSizeScales()
        .then((response) => {
          this.allSizeScales = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    validateForm() {
      if (!this.sizeScale.code || this.sizeScale.code.trim() === "") {
        return false;
      }

      const filledSizes = this.indSizes.filter((s) => s && s.trim() !== "");
      if (filledSizes.length === 0) {
        return false;
      }

      const uniqueSizes = [...new Set(filledSizes.map((s) => s.trim()))];
      if (uniqueSizes.length !== filledSizes.length) {
        return false;
      }
      return true;
    },
    checkDuplicateIndSize() {
      const filledSizes = this.indSizes.filter((s) => s && s.trim() !== "");
      const id = this.editId !== 0 ? this.sizeScale.id : null;

      for (const size of filledSizes) {
        const duplicate = this.allSizeScales.find((item) => {
          if (id && item.id === id) return false;
          return (
            item.code === this.sizeScale.code &&
            item.ind_size === size.trim() &&
            item.company_id === this.sizeScale.company_id
          );
        });
        if (duplicate) return true;
      }
      return false;
    },
    save() {
      delete this.sizeScale.companies;

      if (!this.validateForm()) {
        return;
      }

      this.duplicateIndices = this.findDuplicateIndices();
      if (this.duplicateIndices.length > 0) {
        this.duplicateError = true;
        return;
      }
      this.duplicateError = false;
      this.saveData();
    },
    async saveData() {
      const filledSizes = this.indSizes.filter((s) => s && s.trim() !== "");
      this.saving = true;

      try {
        if (this.editId === 0) {
          const promises = filledSizes.map((indSize, index) => {
            const dataToSave = {
              company_id: this.sizeScale.company_id,
              code: this.sizeScale.code,
              ind_size: indSize.trim(),
              sequence_num: index + 1,
            };
            return SizeScaleModel.create(dataToSave);
          });
          await Promise.all(promises);
          this.$emit("closeDialog", true);
        } else {
          const dataToSave = {
            ...this.sizeScale,
            ind_size: filledSizes[0].trim(),
          };
          await SizeScaleModel.update(dataToSave);
          this.$emit("closeDialog", true);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
